// The pieces of two-factor sign-in the sign-in page and Settings share: the
// setup's QR code (drawn here, so the secret never leaves the page), its key
// for typing in, the code field and the recovery codes, shown once.
import qrcode from 'qrcode-generator';

const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

// the otpauth:// link as an SVG QR code
export const qrSvg = uri => {
  const qr = qrcode(0, 'M');
  qr.addData(uri);
  qr.make();
  return qr.createSvgTag({ cellSize: 5, margin: 2, scalable: true });
};

// the key in fours, easier to type
export const groupedSecret = secret => esc(String(secret).replace(/(.{4})/g, '$1 ').trim());

export const codeField = (name = 'code', placeholder = '123456') => `
  <input type="text" name="${name}" inputmode="numeric" autocomplete="one-time-code" maxlength="11"
    placeholder="${placeholder}" required autocapitalize="off" spellcheck="false"
    style="font-size: 22px; letter-spacing: 4px; text-align: center; max-width: 220px; margin: 0 auto; display: block;" />
`;

// scan the code, or type the key; then the app's first code
export const setupHtml = setup => `
  <ol class="two-factor-steps" style="text-align: left; margin: 0 0 14px 20px; padding: 0;">
    <li style="margin-bottom: 6px;">Open an authenticator app on your phone: Google Authenticator, Microsoft Authenticator, 1Password or another.</li>
    <li style="margin-bottom: 6px;">Scan this code with it.</li>
    <li>Enter the six-digit code the app shows.</li>
  </ol>
  <div class="two-factor-qr" style="width: 190px; margin: 0 auto 10px; background: #fff; padding: 6px; border-radius: 8px; border: 1px solid #e3e6ee;">${qrSvg(setup.uri)}</div>
  <p style="font-size: 13px; color: #666; margin: 0 0 14px; text-align: center;">Can't scan it? Enter this key in the app:<br /><code style="font-size: 14px; user-select: all;">${groupedSecret(setup.secret)}</code></p>
`;

/**
 * The recovery codes, shown once, with a way to keep them. Each works once
 * in place of a code when the phone is lost.
 */
export const recoveryCodesHtml = codes => `
  <div class="two-factor-recovery" style="text-align: left;">
    <p style="margin: 0 0 8px;"><b>Save your recovery codes.</b> Each one signs you in once if you lose your phone. They're shown only now.</p>
    <pre class="two-factor-recovery__codes" style="background: #f5f7fb; border-radius: 8px; padding: 12px 16px; font-size: 15px; line-height: 1.7; columns: 2; margin: 0 0 10px; user-select: all;">${codes.map(esc).join('\n')}</pre>
    <p style="margin: 0;">
      <button type="button" class="button button--small hollow" data-action="copy_recovery_codes">Copy</button>
      <button type="button" class="button button--small hollow" data-action="download_recovery_codes">Download</button>
    </p>
  </div>
`;

// the Copy and Download buttons of recoveryCodesHtml() inside $root
export const bindRecoveryCodes = ($root, codes) => {
  const text = `Temp Stick Enterprise recovery codes\nEach works once.\n\n${codes.join('\n')}\n`;

  $root.on('click', '[data-action="copy_recovery_codes"]', e => {
    const done = () => { e.currentTarget.textContent = 'Copied'; };
    if(navigator.clipboard) {
      navigator.clipboard.writeText(text).then(done).catch(() => {});
    }
  });

  $root.on('click', '[data-action="download_recovery_codes"]', () => {
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([text], { type: 'text/plain' }));
    a.download = 'temp-stick-enterprise-recovery-codes.txt';
    document.body.appendChild(a);
    a.click();
    a.remove();
  });
};
